import Negotiator from 'negotiator';

/** Negotiates the best available locale from an HTTP Accept-Language header, defaulting to "es". */
export function detectLocale<T extends string>(acceptLanguage: string | null, availableLocales: readonly T[]): T {
	if (!acceptLanguage) return 'es' as T;
	const negotiator = new Negotiator({ headers: { 'accept-language': acceptLanguage } });
	return (negotiator.language(availableLocales as unknown as string[]) ?? 'es') as T;
}
